export enum Channel {
  Retail = 'Retail',
  Wholesale = 'Wholesale',
  Broker = 'Broker',
  Correspondent = 'Correspondent',
  NonDelegatedCorrespondent = 'NonDelegatedCorrespondent',
  JointVenture = 'JointVenture',
  Direct = 'Direct',
}
